import { render, staticRenderFns } from "./modal-confirm-remove.vue?vue&type=template&id=952a7b6c&scoped=true"
import script from "./modal-confirm-remove.vue?vue&type=script&lang=js"
export * from "./modal-confirm-remove.vue?vue&type=script&lang=js"
import style0 from "./modal-confirm-remove.vue?vue&type=style&index=0&id=952a7b6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "952a7b6c",
  null
  
)

export default component.exports